import { useEffect, useState } from "react";
import { format } from "date-fns";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { adminApi } from "@/lib/adminApi";

export default function SubscribersPanel() {
  const [data, setData] = useState({ subscribers: [], count: 0 });
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    adminApi.get("/subscribers").then(setData).catch(() => {});
  }, []);

  const exportCsv = async () => {
    setExporting(true);
    try {
      const blob = await adminApi.getBlob("/subscribers/export");
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `shi-sheet-subscribers-${format(new Date(), "yyyy-MM-dd")}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success("Subscriber list exported.");
    } catch {
      toast.error("Export failed. Try again.");
    } finally {
      setExporting(false);
    }
  };

  return (
    <div data-testid="admin-subscribers-panel">
      <div className="flex flex-wrap items-start justify-between gap-4 rounded-2xl border border-gold/30 bg-cocoa p-8">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-latte">
            The Shi Sheet
          </p>
          <p data-testid="admin-subscriber-count" className="mt-2 font-display text-5xl font-black text-gold">
            {data.count}
          </p>
          <p className="mt-1 text-sm text-latte">subscribers on the list</p>
        </div>
        <button
          data-testid="subscribers-export-csv"
          onClick={exportCsv}
          disabled={exporting || data.count === 0}
          className="inline-flex items-center gap-2 rounded-full border border-gold/50 px-5 py-2.5 text-sm font-semibold text-gold transition-colors hover:bg-gold hover:text-ink disabled:cursor-not-allowed disabled:opacity-50"
        >
          <Download size={15} /> {exporting ? "Exporting…" : "Export CSV"}
        </button>
      </div>

      <div className="mt-8 divide-y divide-corduroy rounded-2xl border border-corduroy">
        {data.subscribers.map((s) => (
          <div key={s.id} data-testid={`admin-subscriber-${s.id}`} className="flex items-center justify-between px-6 py-4">
            <span className="text-sm text-cream">{s.email}</span>
            <span className="text-xs text-latte">
              {s.subscribed_at ? format(new Date(s.subscribed_at), "MMM d, yyyy") : ""}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
